import {
  Cascader as AntCascader,
  CascaderProps as AntCascaderProps,
} from "antd";
import { DefaultOptionType } from "antd/es/cascader";
import React from "react";
import * as styles from "./Cascader.css";
export type CascaderOption = {
  value: string | number;
  label: React.ReactNode;
  children?: CascaderOption[];
  disabled?: boolean;
  isLeaf?: boolean;
} & DefaultOptionType;
export type CascaderProps = {
  options: CascaderOption[];
} & AntCascaderProps;

const _styleImport = styles;

const Cascader: React.FC<CascaderProps> = ({ options, ...props }) => (
  <AntCascader options={options} {...props} />
);
export default Cascader;
